import merge from 'lodash/merge'
import baseStyles from '../Base/Base.styles'
import BaseImageStyles from '../BaseImage/BaseImage.styles'
import { parseResponsiveProperty, breakpointsMediaInversed } from '@converdy/styles'


export default properties => {

  const { layout, background, base, mirror, image, gap } = properties

  let jss = {
    root: {
      ...baseStyles(base),
      ...parseResponsiveProperty((c) => ({'--gap': `${c}px` }), gap),
      '& .image-wrapper': {
        position: 'relative',
        paddingTop: '100%'
      },

      '& .image-wrapper img': {
        ...BaseImageStyles(image),
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center center',
        position: 'absolute',
        top: '0',
        left: '0',
      },

      '& .image-and-text-right': {
        display: 'flex',
        alignItems: 'center',
      },
      
      [breakpointsMediaInversed.tablet]: {
        '& .image-and-text-right': {
          order: mirror ? 0 : 1
        },
      },
      
      [breakpointsMediaInversed.tablet]: {
        '& .image-and-text-left': {
          order: mirror ? 0 : 1
        },
      }
    }
  }


    merge(jss.root, {
      '& > .box': parseResponsiveProperty(v => {
        return v && v.value && v.unit ? {
          height: v.value + v.unit,
        } : {} 
      }, mirror)
    })


  return jss

}
